import {Link} from "react-router-dom";
import FeedbackFormModal from "../components/FeedbackFormModal";
import logo from "../logos/logo1.png";

const Footer: React.FC = () => {
  return (
    <>
      <footer className="flex lg:mt-10 justify-between footer footer-horizontal bg-gradient-to-b from-white to-valpeacock lg:bg-none lg:bg-footerlightgray text-black p-5 text-[13px]">
        <div className="hidden lg:block lg:w-[90%] xl:w-[80%] mx-auto">
          <div className="w-full">
            <p>© 2026 Value Analytics Labs | All rights reserved</p>
            <div className="grid grid-cols-3">
              <p className="text-start">
                <span className="font-bold">Funding: </span>
                Funding provided by Cytokinetics
              </p>
              <p className="text-center">
                <span className="font-bold">Contact: </span>
                mbutzner@cytokinetics.com
              </p>
              <p className="text-center">
                <div>
                  <button
                    className="font-bold cursor-pointer"
                    onClick={() =>
                      document.getElementById("feedback").showModal()
                    }>
                    Give Feedback
                  </button>
                </div>
              </p>
            </div>
          </div>
        </div>
        <div className="w-full block lg:hidden">
          <div className="md:hidden">
            <div className="flex justify-center w-[calc(90vw)] mb-11">
              <img src={logo} className="h-[85px] w-[238px]" alt="" />
            </div>
            <div className="text-white mb-9">
              <p className="text-[24px] font-bold line-height-[120%]">Links</p>
              <div className="text-[16px] font-normal text-[#FFFFFFB2] line-height-[120%] grid grid-cols-3 my-6">
                <Link to="/" className="my-3">
                  Home
                </Link>
                <Link to="/methodology" className="my-3">
                  Method
                </Link>
                <Link to="/news" className="my-3">
                  News
                </Link>
                <Link to="/tool" className="my-3">
                  Tool
                </Link>
                <Link to="/team" className="my-3">
                  Team
                </Link>
                <Link to="/research" className="my-3">
                  Publications
                </Link>
              </div>
            </div>
            <div className="w-[80%] text-white">
              <p className="my-3">
                &copy; 2026 Value Analytics Labs | All rights reserved
              </p>
              <p className="my-3">
                <span className="font-bold">Funding: </span>
                Funding provided by Cytokinetics
              </p>
              <p className="my-3">
                <div>
                  <button
                    className="font-bold cursor-pointer"
                    onClick={() =>
                      document.getElementById("feedback").showModal()
                    }>
                    Give Feedback
                  </button>
                </div>
              </p>
            </div>
          </div>
          <div className="hidden w-full md:block">
            <div className="grid grid-cols-2">
              <div className="flex justify-center w-full">
                <img src={logo} className="h-[85px] w-[238px]" alt="" />
              </div>
              <div className="grid grid-cols-2 pt-10 mb-4">
                <div>
                  <Link
                    className="block text-white mb-4 text-[#FFFFFFB2]"
                    to={"/"}>
                    Home
                  </Link>
                  <Link
                    className="block text-white mb-4 text-[#FFFFFFB2]"
                    to={"/methodology"}>
                    Method
                  </Link>
                  <Link
                    className="block text-white mb-4 text-[#FFFFFFB2]"
                    to={"/news"}>
                    News
                  </Link>
                </div>
                <div className="">
                  <Link
                    className="block text-white mb-4 text-[#FFFFFFB2]"
                    to={"/tool"}>
                    Tool
                  </Link>
                  <Link
                    className="block text-white mb-4 text-[#FFFFFFB2]"
                    to={"/team"}>
                    Team
                  </Link>
                  <Link
                    className="block text-white mb-4 text-[#FFFFFFB2]"
                    to={"/research"}>
                    Publication
                  </Link>
                </div>
              </div>
            </div>
            <div className="bg-[#FFFFFF38] h-[1px] w-full"></div>
            <div className="flex justify-between flex-wrap mt-3">
              <p className="text-white text-[12px]">
                &copy; 2026 Value Analytics Labs | All rights reserved
              </p>
              <p
                className="text-white text-[12px] cursor-pointer"
                onClick={() => document.getElementById("feedback").showModal()}>
                Give Feedback
              </p>
              <p className="text-white text-[12px]">
                <span className="font-bold">Funding: </span>
                Funding provided by Cytokinetics
              </p>
            </div>
          </div>
        </div>
        <FeedbackFormModal />
      </footer>
    </>
  );
};

export default Footer;
